const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class HistoricTerritory extends Territory {
    constructor(age){
        super(
            age,
            TerritoryNames.HistoricTerritory,
            "Gain " + HistoricTerritory.GetCultureCount(age) + " culture and " + HistoricTerritory.GetHappyCount(age) + " happy face(s).",
            {}
        )
    }

    static GetCultureCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 6;
            case Age.Age2:
                return 11;
        }
    }

    static GetHappyCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 1;
            case Age.Age2:
                return 2;
        }
    }
}

module.exports = HistoricTerritory;